import { ToastrModule } from 'ngx-toastr'
import { environment } from 'src/environments/environment'

import { ErrorHandler, NgModule } from '@angular/core'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'

import { MetaReducer, StoreModule } from '@ngrx/store'
import { StoreDevtoolsModule } from '@ngrx/store-devtools'
import { TranslateLoader, TranslateModule } from '@ngx-translate/core'

import { AuthModule } from './auth/auth.module'
import { reducers } from './core.state'
import { AppErrorHandler } from './error-handler.service'
import { LocalStorageService } from './local-storage.service'
import { NotificationService } from './notification.service'
import { localStorageSyncReducer } from './storage.reducer'
import { TranslatorService } from './translator.service'
import { UtilityService } from './utility.service'
import { PushNotificationService } from './push-notification.service'
import { provideHttpClient, withInterceptors } from '@angular/common/http'
import { AuthRetryInterceptor } from './interceptors/auth-retry.interceptor'
import { ErrorHandlerInterceptorInterceptor } from './interceptors/error.interceptor'
import { TokenInterceptor } from './interceptors/token.interceptor'
import { UserRoleHttpHeaderInterceptor } from './interceptors/user-role.interceptor'
import { LanguageHeaderInterceptor } from './interceptors/language-header.interceptor'
import { PlatformInterceptor } from './interceptors/platform.interceptor'
import { I18nHashTranslateLoader } from './i18n-hash-translate-loader'

const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer]

@NgModule({
  declarations: [],
  exports: [TranslateModule],
  imports: [
    BrowserAnimationsModule,
    StoreModule.forRoot(reducers, {
      metaReducers
    }),
    environment.production
      ? []
      : StoreDevtoolsModule.instrument({
          name: 'Angular NgRx'
        }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: I18nHashTranslateLoader
      },
      fallbackLang: 'en'
    }),
    ToastrModule.forRoot(),
    AuthModule
  ],
  providers: [
    LocalStorageService,
    TranslatorService,
    NotificationService,
    PushNotificationService,
    provideHttpClient(
      withInterceptors([
        TokenInterceptor,
        UserRoleHttpHeaderInterceptor,
        LanguageHeaderInterceptor,
        PlatformInterceptor,
        ErrorHandlerInterceptorInterceptor,
        AuthRetryInterceptor
      ])
    ),
    {
      provide: ErrorHandler,
      useClass: AppErrorHandler
    },
    UtilityService
  ]
})
export class CoreModule {}
